import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["DemoProvider"] */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/components/DemoContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoModal"] */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/components/DemoModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InteractiveControls"] */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/components/InteractiveControls.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/analysis.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/book-coins-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/channel-add-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/circle-down-split-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/cog-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/grid-dots-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/group-list-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/heart-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/login.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/store.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/summarize-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/task-list-80.png");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/pulse/extensions/excel/images/word-count-80.png");
